const pharmacyTypes = {
  zipdrug: 'Zipdrug',
  cpesn: 'CPESN (Community Pharmacy Enhanced Services Network)',
};

export default pharmacyTypes;
